import i18n from 'src/assets/i18n/i18n'
import { Toaster } from 'src/utils/helper/toaster'

const createErrorObject = function (error) {
  return {
    status: (error.response?.status) || '',
    message: (
      (error.response?.data?.error) ||
      (error.response?.data?.message) ||
      error.statusText || error.message || ''
    ),
    plain: error
  }
}

export default {
  namespaced: true,
  $t : i18n().global.t,

  state: {
    errors: []
  },

  getters: {
    list: state => {
      return state.errors
    }
  },

  mutations: {
    add (state, error) {
      /**
       * Do not add an error message
       * for the following types of errors:
       *
       * 401 error (session expired)
       * 403 error (session without foundryId)
       */
      if (![401, 403, 999].includes(error.response?.status ?? 0)) {
        if (error.name !== 'Validation Error') {
          Toaster.notifyError(createErrorObject(error).message)
        }
      }
    },
    clear (state) {
      state.errors = []
    },
    clearOneByOne (state, val) {
      const index = state.errors.indexOf(val)
      if (index > -1) {
        state.errors.splice(index, 1)
      }
    }
  },

  actions: {
    throw ({ commit }, error) {
      commit('add', error)
    }
  }
}
